import { AppConfig, CoreShopEnvironment } from '@App/Main.types';
import { ExperimentFeatureSets, Experiments, FeatureSet, FeatureSets } from '@Config/Experiments';
import { ExperimentSet, ExperimentStatusDetails } from '@Framework/experiments';

type FeatureValue = string | number | boolean;

export type ConfigValue =
  | string
  | boolean
  | number
  | null
  | { [key: string]: FeatureValue }
  | FeatureSet
  | FeatureSets
  | ExperimentSet;

// @ts-ignore
export class ConfigRaw implements AppConfig {
  private static _instance: ConfigRaw;
  private storeDefault: AppConfig = {
    coreShopEnvironment: CoreShopEnvironment.Qs,
    experiments: <ExperimentSet>{},
    features: <FeatureSet>{},
    language: '',
    tenant: '',
    triggerTrackingEvent: undefined,
    referrerUrl: ''
  };
  private store: AppConfig = JSON.parse(JSON.stringify(this.storeDefault));

  public clear(): void {
    this.setAll(JSON.parse(JSON.stringify(this.storeDefault)));
  }

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public set(key: string, value: ConfigValue) {
    this.store[key] = value;

    if (key === 'experiments') {
      const item = <ExperimentSet>value;
      Object.keys(item).map(key => {
        const details = <ExperimentStatusDetails>item[key];
        const features = ExperimentFeatureSets[key]?.[details.variant];

        if (features !== undefined) {
          this.set('features', {
            // @ts-ignore
            ...this.store['features'],
            ...features
          });
        }
      });
    }
  }

  public has(key: string): boolean {
    const value = this.get(key, null);
    return value !== null && value !== '';
  }

  public get<T extends ConfigValue>(key: string, defaultValue?: T): T & ConfigValue {
    if (defaultValue === undefined && this.store[key] === undefined) {
      throw new Error(`${key} doesnt exists in config`);
    }

    //@ts-ignore
    return this.store[key] ?? defaultValue;
  }

  setAll(config: Partial<AppConfig>) {
    for (const x in config) {
      this.set(x, config[x]);
    }
  }
}

export const Configurator = ConfigRaw.Instance;

const proxy = new Proxy(ConfigRaw.Instance, {
  get(target: ConfigRaw, name: string | symbol) {
    if (typeof name === 'string' && target.has(name)) {
      return target.get(name);
    }

    return target[name];
  }
});

// looks strange, is strange but it works as you would expect it to work
// "if it looks stupid but it works it isn't stupid" - some unknown engineer
// @ts-ignore
export const Config = <AppConfig>proxy;
